import { PageHeader } from "../components/layout/PageHeader";
import { MessageSquare, Plus, Send, ShieldAlert, Users, Wand2 } from "lucide-react";

const SEQUENCES = [
  { id: "s1", name: "Webinar live · 5 min", status: "scheduled", sends: 612, replies: 18 },
  { id: "s2", name: "Cart close · last hour", status: "live", sends: 412, replies: 27 },
  { id: "s3", name: "Replay reminder", status: "draft", sends: 0, replies: 0 },
];

const USE_CASES = [
  "Webinar reminders", "Live session reminders", "Book launch alerts",
  "Cart close reminders", "Replay reminders", "Lead magnet follow-up",
  "Event reminders", "Client onboarding",
];

export default function SMS() {
  return (
    <div data-testid="sms-page" className="space-y-8">
      <PageHeader
        kicker="Reach · SMS"
        title="SMS sequences"
        description="Premium SMS that ships. Twilio / Telnyx providers, STOP/HELP compliance, quiet hours, and reply tracking."
        actions={
          <button
            data-testid="sms-new-btn"
            className="inline-flex items-center gap-2 px-4 h-11 rounded-xl pl-btn-aqua text-sm"
          >
            <Plus className="h-4 w-4" /> New Sequence
          </button>
        }
      />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat icon={Send} label="Sent (30d)" value="2,140" />
        <Stat icon={Users} label="Subscribers" value="3,420" />
        <Stat icon={MessageSquare} label="Reply rate" value="6.4%" />
        <Stat icon={ShieldAlert} label="Opt-outs" value="0.3%" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 rounded-2xl p-5 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pl-aqua)]">Active Sequences</div>
          <div className="mt-3 divide-y divide-[var(--pl-border)]">
            {SEQUENCES.map((s) => (
              <div key={s.id} className="py-3 flex items-center gap-3" data-testid={`sms-seq-${s.id}`}>
                <div className="h-9 w-9 rounded-xl bg-[var(--pl-lime)]/10 border border-[var(--pl-lime)]/30 grid place-items-center">
                  <MessageSquare className="h-4 w-4 text-[var(--pl-lime)]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-[var(--pl-text)] truncate">{s.name}</div>
                  <div className="text-[11px] text-[var(--pl-text-muted)]">
                    {s.sends.toLocaleString()} sent · {s.replies} replies
                  </div>
                </div>
                <span
                  className={`text-[10px] px-2 py-0.5 rounded-md capitalize border ${
                    s.status === "live"
                      ? "bg-emerald-500/10 border-emerald-500/40 text-emerald-300"
                      : s.status === "scheduled"
                      ? "bg-[var(--pl-aqua)]/10 border-[var(--pl-aqua)]/40 text-[var(--pl-aqua)]"
                      : "bg-white/5 border-[var(--pl-border)] text-[var(--pl-text-muted)]"
                  }`}
                >
                  {s.status}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl p-5 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--pl-aqua)]">Use Cases</div>
          <div className="mt-3 space-y-1.5">
            {USE_CASES.map((u) => (
              <div
                key={u}
                data-testid={`sms-uc-${u}`}
                className="flex items-center gap-2 px-3 py-2 rounded-xl border border-[var(--pl-border)] bg-white/[0.03] hover:border-[var(--pl-lime)]/40 cursor-pointer text-sm text-[var(--pl-text)]"
              >
                <Wand2 className="h-4 w-4 text-[var(--pl-lime)]" /> {u}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: I, label, value }) {
  return (
    <div className="rounded-2xl p-4 border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
      <div className="flex items-center gap-2 text-[var(--pl-text-muted)]">
        <I className="h-4 w-4 text-[var(--pl-lime)]" />
        <div className="text-[10px] uppercase tracking-[0.22em]">{label}</div>
      </div>
      <div className="font-display text-2xl font-semibold mt-1.5 text-[var(--pl-text)]">{value}</div>
    </div>
  );
}
